import styled from 'styled-components';

export const ProfileAuthWrapper = styled.div`
    height: 36px;
    display: flex;
    gap: 8px;
    flex-basis: max-content;
`;
